import React from 'react';
import { Checkbox as AntdCheckbox } from 'antd';
import { CheckboxProps } from 'antd/lib/checkbox';
import classNames from 'classnames';

import styles from './checkbox-component.module.scss';

const CheckboxComponent: React.FC<CheckboxProps> = (props: CheckboxProps) => {
    const { value, className, ...rest } = props;

    const checkboxClassName: string = classNames(className, styles.checkbox);

    return <AntdCheckbox {...rest} checked={!!value} className={checkboxClassName} />;
};

export { CheckboxComponent };
